import PropTypes from 'prop-types';
import cn from 'classnames';
import format from 'date-fns/format';
import common from 'constants/common';
import ConnectLogo from 'components/atoms/icons/connectLogoIcon';
import CallSubComment from '../callSubComments';

const WaitCallDetails = ({ comment, id, solid }) => (
  <tr className={cn({ 'no-strip': solid })}>
    <td className="col-1 text-center">{id}</td>
    <td className="col-8 comment">
      {comment.callComments && comment.callComments.length > 0 && (
        <>
          <strong>Call comments</strong>
          {comment.callComments.map((callComment) => (
            <CallSubComment data={callComment} key={callComment.callId} />
          ))}
        </>
      )}

      <p>Audio</p>
      <span>Waiting for call details</span>
      <span>
        Call By: {comment.createdByTitle} {comment.createdByFirstName}{' '}
        {comment.createdByLastName}
        {comment.createdByProfessionType ? ' - ' : ' '}
        {comment.createdByProfessionType}
      </span>
    </td>
    <td className="col-3 info">
      <ConnectLogo />
      <span>
        {comment.createdAt
          ? format(new Date(comment.createdAt), common.dateFormats.dateAndTime)
          : ''}
      </span>
      {comment.commentType && (
        <span
          className="comment-type"
          style={{
            marginBottom: '0px',
            display: 'inline-flex',
            textTransform: 'uppercase',
          }}
        >
          {comment.commentType}
        </span>
      )}
    </td>
  </tr>
);

WaitCallDetails.propTypes = {
  comment: PropTypes.shape().isRequired,
  id: PropTypes.number.isRequired,
  solid: PropTypes.bool,
};

export default WaitCallDetails;
